<template>
  <div class="shop-content-wrap">
    <template v-if=" selectedFilterProducts != null">
      <v-row>
        <v-col v-for="(category,index) in resultList" cols="12" sm="6" md="4" lg="3" :key="index">
          <product-item :data="category"></product-item>
        </v-col>
      </v-row>
    </template>
    <div class="pagination-wrap pt-2" v-if="resultList.length">
      <v-pagination v-model="page" class="my-4" :length="Math.ceil(selectedFilterProductsLength/8)"></v-pagination>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ProductItem from "./ProductItem";
export default {
  components: {
    ProductItem,
  },
  props: ["labels"],
  data() {
    return {
      categoryList: [],
      // category: "",
      subCategory: "",
      layout: "grid",
      sortKey: null,
      sortOrder: null,
      sortField: null,
      page: 1,
      // sortOptions: [
      //   // { label: "", value: "!sellingPrice" },
      //   // { label: "", value: "sellingPrice" },
      // ],
    };
  },
  computed: {
    ...mapGetters([
      "products",
      "selectCurrency",
      "rtlLayout",
      "selectedFilterValue",
      "selectedFilterProducts",
      "selectedFilterProductsLength",
    ]),
    resultList() {
      return this.selectedFilterProducts.slice(
        (this.page - 1) * 8,
        this.page * 8
      );
    },
  },
  watch: {},
  methods: {
    onPageChange() {
      window.scrollTo(0, 0);
    },
    onSortChange(event) {
      const value = event.value.value;
      const sortValue = event.value;

      if (value.indexOf("!") === 0) {
        this.sortOrder = -1;
        this.sortField = value.substring(1, value.length);
        this.sortKey = sortValue;
      } else {
        this.sortOrder = 1;
        this.sortField = value;
        this.sortKey = sortValue;
      }
    },
  },
  // created() {
  //   if (this.$route.query.category == 0) {
  //     this.category = "";
  //   } else {
  //     this.category = this.$route.query.category
  //       ? this.$route.query.category
  //       : "" || "";
  //   }
  //   if (this.$route.query.subcategory == 0) {
  //     this.subCategory = "";
  //   } else {
  //     this.subCategory = this.$route.query.subcategory
  //       ? this.$route.query.subcategory
  //       : "" || "";
  //   }
  // },
  mounted() {},
};
</script>

